export default __webpack_public_path__ + "static/media/chan eil.f160d20c.mp3";